export default {
    common: {
        notshow: '今日不再顯示',
        unit: 'USDT',
        day: '天',
        week: '週',
        save: '儲存',
        submit: '提交',
        confirmtitle: '確定執行操作',
        confirm: '確認',
        reset: '重置',
        refresh: '刷新',
        copy: '複製',
        copysuccessful: '複製成功',
        modify: '修改',
        binding: '綁定',
        finished: '已完成',
        canceled: '已取消',
        cancel: '取消',
        all: '全部',
        back: '返回',
        loading: '載入中...',
        nomore: '所有記錄',
        errortxt: '載入失敗',
        loosing: '釋放即可刷新...',
        pulling: '下拉即可刷新...',
        nodata: '暫時沒有記錄',
        buy: '買入',
        buyup: '買漲',
        buydown: '買跌',
        sell: '賣出',
        forserver: '請諮詢客服',
        total: '合計',
        status1: '待審核',
        status2: '完成',
        status3: '未通過',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: '電匯'
    },
    footer: {
        home: '主頁',
        market: '行情',
        exchange: '幣幣',
        options: '期權',
        assets: '資產',
        change: '劃轉',
        recharge: '充幣',
        withdrawal: '提幣'
    },
    home: {
        menu1: '期權交易',
        menu1desc: '支持BTC/USDT等',
        menu2: '快捷充值',
        menu3: '提幣',
        menu4: '在線客服',
        menu5: '閃兌',
        menu6: '助力貸',
        menu7: '鎖倉挖礦',
        menu8: '質押',
        menu9: '帳戶轉帳',
        ranktitle: '漲幅榜',
        name: '名稱',
        price: '最新價',
        risefall: '漲跌幅'
    },
    register: {
        register: '註冊',
        login: '登錄',
        email: 'Email',
        phone: '手機號',
        accountplaceholder: '請輸入帳號',
        emailplaceholder: '請輸入郵箱',
        phoneplaceholder: '請輸入手機',
        pwdplaceholder: '請輸入密碼',
        pwdplaceholder1: '密碼為6-20位任意字母數字',
        agepwdplaceholder: '請再次輸入密碼',
        agepwdplaceholder1: '兩次輸入密碼不相同',
        invitecodeplaceholder: '請輸入邀請碼',
        remember: '記住密碼',
        fotget: '忘記密碼'
    },
    market: {
        title: '行情',
        all: '全部'
    },
    member: {
        reputation: '信譽分',
        identity_authentication: '身份認證',
        under_review: '審核中',
        certified: '已認證',
        awaiting_certification: '待認證',
        binding_withdrawal_address: '綁定提幣地址',
        currently_selected_currency: '當前選擇幣種',
        withdrawal_address: '提幣地址',
        sharing_link: '我的分享鏈接',
        my_promotion_code: '我的推廣碼',
        promotion_code: '推廣碼',
        system_message: '系統消息',
        night_mode: '夜間模式',
        security_center: '安全中心',
        seted: '已設置',
        noset: '未設置',
        login_password: '登錄密碼',
        transaction_password: '提現密碼',
        app_download: 'App 下載',
        log_out: '退出登錄',
        aboutus: '網站介紹'
    },
    identity: {
        title: '身份認證',
        name: '姓名',
        nameplaceholder: '請輸入真實姓名',
        uploader: '上傳身份證照片',
        tip1: '上傳身份證正面',
        tip2: '上傳身份證反面'
    },
    address: {
        title: '綁定提幣地址',
        bType: '當前選擇幣種',
        address: '提幣地址',
        addressplaceholder: '請輸入提幣地址'
    },
    security: {
        title: '安全中心',
        modifypwd: '登錄密碼',
        resetlegalpwd: '交易密碼',
        loginpwd: '新登錄密碼',
        pwdage: '確認密碼',
        loginpwdplaceholder: '請輸入當前登錄密碼',
        loginnewpwdplaceholder: '請輸入新的登錄密碼',
        moneypwd: '請輸入交易密碼',
        pwdageplaceholder: '請再次輸入密碼'
    },
    trade: {
        title: '幣幣交易',
        price: '價格',
        num: '數量',
        entrust: '當前委託',
        clinch: '實際成交',
        used: '可用',
        buyed: '可買',
        amount: '交易額',
        limitprice: '限價',
        marketprice: '市價',
        forprice: '以當前最優價格交易',
        errorMoney: '可用餘額不足',
        priceerror: '請輸入委託價格',
        numerror: '請輸入委託數量',
        moneyerror: '請輸入委託金額'
    },
    assets: {
        allconvert: '總資產折合',
        usenum: '可用',
        freeze: '凍結',
        convert: '折合',
        tab1: '資產',
        tab11: '總資產折合',
        tab12: '期權折合',
        tab13: '資金折合',
        tab14: '量化折合',
        tab2: '期權',
        tab21: '期權帳戶',
        tab3: '資金',
        tab31: '資金帳戶',
        tab4: '量化',
        tab41: '量化帳戶',
        tbhead1: '財務記錄',
        tbhead2: '提幣記錄',
        tbhead3: '充幣記錄',
        tbhead4: '劃轉記錄',
        rcdnum: '數量',
        rcd: '記錄',
        rcdtime: '時間',
        rcdstatus: '狀態',
        rcddesc: '備註',
        rcdaddress: '充幣地址'
    },
    change: {
        title: '劃轉',
        from: '從 {name}',
        to: '到 {name}',
        frmtitle: '劃轉數量',
        inputplaceholder: '請輸入劃轉數量',
        btntxt: '劃轉'
    },
    recharge: {
        title: '充幣',
        bType: '當前幣種',
        address: '充幣地址',
        token: '支付憑證',
        tokenplaceholder: '請上傳支付憑證',
        num: '充值數量',
        numplaceholder: '請輸入數量',
        btn: '提交審核',
        bankname: '銀行名稱',
        bankno: '銀行號碼',
        accountname: '收款帳號名稱',
        bankaddress: '銀行地址',
        bankcode: '銀行匯款代碼',
        companyaddress: '公司地址'
    },
    withdrawal: {
        title: '提幣',
        frmtitle1: '數量',
        frmplaceholder1: '提幣數量在 {min} - {max} 之間',
        frmtitle2: '交易密碼',
        frmplaceholder2: '請輸入交易密碼',
        getnum: '到賬數量',
        fee: '手續費',
        btn: '提幣'
    },
    exchangeb: {
        title: '兌換',
        account: '帳戶',
        btn: '兌換',
        numerror: '請輸入兌換數量'
    },
    option: {
        title: '期權',
        typetitle: '秒合約',
        listtitle: '持倉',
        kline: 'K線',
        high: '高',
        low: '低',
        nums: '24H量',
        time: '時間',
        transaction: '交易模式',
        quantity: '開倉數量',
        quantityerror: '請輸入開倉數量',
        times: '開倉時間',
        times1: '結算時間',
        account: '帳戶餘額',
        buyup: '買漲',
        buydown: '買跌',
        tab1: '持倉列表',
        tab2: '訂單記錄',
        num: '數量',
        price1: '購買價',
        price2: '成交價',
        profitandloss: '預計盈虧',
        profitandloss1: '盈虧',
        countdown: '倒計時',
        waitfinish: '待結算',
        finishing: '結算中...',
        finished: '已結算',
        order_price: '現價',
        order_cycle: '週期',
        order_type: '類型',
        order_money: '金額',
        order_time: '建倉',
        order_get: '盈利',
        order_btn: '繼續下單'
    },
    tradelst: {
        title: '我的委託',
        tab1: '委託',
        tab2: '交易完成',
        tab3: '已撤銷',
        usdtnum: ''
    },
    loans: {
        repayment:'立即還款',
        title: '助力貸',
        order_tab: '貸款訂單',
        pro_tab: '貸款產品',
        Institution: '放款機構',
        Amount: '金額',
        DailyInterest: '日利率',
        RepaymentPeriod: '還款週期',
        Application: '申請貸款',
        orderno: '訂單號',
        AllInterest: '總利息',
        RepaymentDate: '還款日期',
        RepaymentMethod: '還款方式',
        Onetime: '一次性',
        Expected_loan_amount: '期望借款金額',
        Expected_loan_amounterror: '借款金額範圍在 {min} - {max} 之間',
        imgplaceholdr: '信用放貸(請確保圖片清晰可見)',
        icon1: '上傳證件正面',
        icon2: '上傳證件反面',
        icon3: '上傳手持證件',
        status1: '申請中',
        status2: '申請通過',
        status3: '申請失敗'
    },
    lockming: {
        title: '鎖倉挖礦',
        order_tab: '礦機訂單',
        pro_tab: '礦機市場',
        locknum: '最小鎖倉數量',
        getforday: '收益率/天數',
        days: '天數',
        estimation: '預估收益',
        real: '已收益',
        balance: '錢包餘額',
        nums: '鎖倉數量',
        tolockming: '鎖倉',
        stime: '開始時間',
        etime: '結束時間'
    },
    transfer: {
        title: '帳戶轉帳',
        searchtxt: '請輸入對方帳號',
        ReceivingAccount: '收款帳戶信息',
        toaccount: '帳戶',
        confirmtxt: '請點擊確認收款帳戶',
        confirmedtxt: '已確認收款帳戶',
        numtxt: '轉帳數量',
        numerror: '請輸入轉帳數量',
        fee: '內部轉帳免手續費',
        ArrivalTime: '到賬時間',
        Immediately: '立即到賬',
        realnum: '實際到賬數量',
        btn: '確認轉帳',
        transfering: '劃轉中',
        orderNo: '訂單號',
        stime: '劃轉時間',
        etime: '到賬時間',
        receiving: '收款帳戶',
        type: '幣種',
        num: '劃轉數量',
        arrivalnum: '入賬數量'
    },
    staking: {
        title: '質押',
        record: '記錄',
        getforyear: '參考年化收益',
        time: '投資期限',
        snum: '起投數量',
        snumerror: '請輸入起投數量',
        snumerror1: '起投數量不低於 {num}',
        join: '立即參與',
        opentime: '建倉時間',
        money: '投入金額',
        days: '週期',
        recordget: '年化收益',
        gets: '收益',
        stime: '開始日期',
        etiem: '結束日期',
        redeemStaking: '撤銷',
        status0: '質押中',
        status1: '訂單結束',
        status2: '訂單贖回'
    },
    bank:{
        title: '綁定銀行卡',          // 需同步顯示銀行官方APP操作界面用詞‌:ml-citation{ref="3,4" data="citationList"}
        bankName: '銀行名稱',         // 國際SWIFT系統標準命名規則‌:ml-citation{ref="5" data="citationList"}
        bankNameError: '請輸入銀行名稱', // 金融機構實名制驗證要求‌:ml-citation{ref="1,4" data="citationList"}
        usrName: '持卡人',           // 反洗錢法規身份驗證條款‌:ml-citation{ref="4,6" data="citationList"} 
        usrNameError: '請輸入持卡人',   // 第三方支付平台通用驗證機制‌:ml-citation{ref="1" data="citationList"}
        cardCode: '銀行卡號',         // 遵循ISO/IEC 7812國際標準‌:ml-citation{ref="6" data="citationList"}
        cardCodeError: '請輸入銀行卡號', // 支付卡產業數據安全標準(PCI DSS)‌:ml-citation{ref="3,6" data="citationList"}
        towallet: '提幣到錢包',        // 數位資產交易平台通用術語‌:ml-citation{ref="2,5" data="citationList"}
        tobank: '提幣到銀行卡',        // 跨境資金清算特殊標註要求‌:ml-citation{ref="5" data="citationList"}
        sendcode: '發送驗證碼',        // 雙因素身份驗證規範‌:ml-citation{ref="1,5" data="citationList"}
        sended: '{num}秒後重新發送',    // 金融級別時效性控制標準‌:ml-citation{ref="1,3" data="citationList"}
        verify_code: '請輸入電子郵箱驗證碼' // 個人資料保護法(PDPA)要求‌:ml-citation{ref="4,5" data="citationList"}
      }
      
}
